function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M234.667 128h42.667v170.667h-42.667zM149.333 128H192v170.667h-42.667z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M213.333 0C95.467 0 0 95.467 0 213.333s95.467 213.333 213.333 213.333S426.667 331.2 426.667 213.333 331.2 0 213.333 0zm0 384c-94.08 0-170.667-76.587-170.667-170.667S119.253 42.667 213.333 42.667 384 119.253 384 213.333 307.413 384 213.333 384z"
});

var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 426.667 426.667",
    fill: "#9193A9"
  }, props), _ref, _ref2);
};

export default SvgPause;